import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";

const mapStateToProps = (state) => {
  return {
    amenitiesData: state.common.amenitiesData,

    networkData: state.common.networkData,
    chargerTypes:state.common.chargerTypes
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAmenitiesAction: commonActions.getAmenitiesData,
      getNetworkAction: commonActions.getNetworkData,
      getchargerTypeAction:commonActions.chargerTypeAction
    },
    dispatch
  );

const AddStationStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default AddStationStore;
